import React from 'react';

const AddParishLink = () => (
  <a className="d-inline-block" href="https://parafio.com" target="_blank" rel="noreferrer">
    Parafio.com
  </a>
);

export default AddParishLink;
